import { render } from "./Erp.vue?vue&type=template&id=cc8b39da"
import script from "./Erp.vue?vue&type=script&lang=js"
export * from "./Erp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__